export default __webpack_public_path__ + "static/media/submission-background.9b122cc9.jpg";